$(document).ready(function () {
  AOS.init();
  header();
  footer();

  refreshFsLightbox();
  gsap.registerPlugin(ScrollTrigger);
  //------------------------------------ header

  // check
  $('.prv').click(function () {
    $('.form-popup').fadeIn(); // 부드럽게 보이기
    $('.popup-bg').addClass('active');
  });

  $('.p-close').click(function () {
    $('.form-popup').fadeOut(100);
    $('.popup-bg').removeClass('active');
    $('html, body').removeClass('lock');
  });

  // lenis
  let lenis;

  lenis = new Lenis({
    duration: 2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // top-btn

  $('.top_btn').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 1200);
  });
});

//sub-nav//////////////////////////////////////
const menuSwiper = new Swiper('.nav-menu-slider', {
  slidesPerView: 'auto',
  freeMode: true,

  // ⭐ 클릭/터치 이슈 해결
  preventClicks: false,
  preventClicksPropagation: false,
  touchStartPreventDefault: false,

  // active 위치 계산을 위해 필요
  watchSlidesProgress: true,
});

// 🔥 active 메뉴 위치로 자연스럽게 이동
(function () {
  const $activeSlide = document.querySelector('.nav-menu-slider .swiper-slide .active');

  if (!$activeSlide) return;

  const slideEl = $activeSlide.closest('.swiper-slide');
  const slideIndex = Array.from(slideEl.parentNode.children).indexOf(slideEl);

  // 즉시가 아닌 자연스럽게 이동
  menuSwiper.slideTo(slideIndex, 300);
})();

// 헤더 //////////////////////////////////////////////////////////////////////////////////////////////
function header() {
  const $header = $('.no-header');

  // GNB 메뉴에 마우스를 올리면 헤더의 높이를 증가
  $('.no-header__gnb--item').mouseover(function () {
    $header.css('height', '40rem');
    $header.addClass('active');
  });

  // 헤더 전체에서 mouseleave 이벤트 발생 시 높이를 초기화
  $header.mouseleave(function () {
    $header.css('height', '');
    $header.removeClass('active');
  });

  $('.close-btn i').mouseover(function () {
    $(this).addClass('--rotate'); // --rotate 클래스 추가
  });

  $('.close-btn i').mouseleave(function () {
    $(this).removeClass('--rotate'); // --rotate 클래스 제거
  });

  $('#hamburger').click(function () {
    $('.toggle-nav').addClass('--drop');
    $('.toggle-nav__gnb').addClass('show');
  });

  $('.close-btn').click(function () {
    $('.toggle-nav').removeClass('--drop');
    $('.toggle-nav__gnb').removeClass('show');
  });

  $('.toggle-nav__lnb .toggle-nav__lnb--item').hover(
    function () {
      const $parent = $(this).closest('.toggle-nav__lnb');
      $parent.addClass('active');
      $parent.find('li').not(this).css('opacity', '0.8');
    },
    function () {
      const $parent = $(this).closest('.toggle-nav__lnb');
      $parent.removeClass('active');
      $parent.find('li').css('opacity', '');
    }
  );

  // 헤더 bg 클래스 처리 함수
  function handleHeaderBg() {
    const scrollTop = $(window).scrollTop();
    const $header = $('.no-header');
    const hasMainVs = $('.main-vs').length > 0;
    const hasSubVisual = $('.no-sub-visual').length > 0;

    // .main-vs 또는 .no-sub-visual이 있을 때만 스크롤 조건 적용
    if (hasMainVs || hasSubVisual) {
      if (scrollTop > 80) {
        $header.addClass('bg');
      } else {
        $header.removeClass('bg');
      }
    } else {
      // 없으면 항상 bg 클래스 유지
      $header.addClass('bg');
    }
  }

  // 페이지 로드 시 초기 상태 설정
  handleHeaderBg();

  // 스크롤 이벤트
  $(window).on('scroll', handleHeaderBg);

  function toggleLnbEvent() {
    var windowWidth = $(window).width();

    if (windowWidth <= 768) {
      $('.toggle-nav__gnb--item')
        .off('click')
        .on('click', function (event) {
          const $target = $(event.target);
          const $thisItem = $(this);
          const subMenu = $thisItem.find('.toggle-nav__lnb');
          const arrowIcon = $thisItem.find('.fa-duotone');

          // 1️⃣ 화살표 클릭 시: 링크 막고 토글만
          if ($target.is('i.fa-duotone')) {
            event.preventDefault();
            event.stopPropagation();

            if (subMenu.is(':visible')) {
              subMenu.slideUp();
              arrowIcon.removeClass('arrow-up');
            } else {
              $('.toggle-nav__lnb').slideUp();
              $('.fa-duotone').removeClass('arrow-up');
              subMenu.slideDown();
              arrowIcon.addClass('arrow-up');
            }

            return;
          }

          // 2️⃣ LNB 안의 링크는 무시 (이동 허용)
          if ($target.closest('.toggle-nav__lnb--link').length > 0) {
            return; // 클릭 통과
          }

          // 3️⃣ GNB 텍스트 클릭 시: 링크 막고 토글
          if ($target.closest('.toggle-nav__gnb--link').length > 0) {
            event.preventDefault();

            if (subMenu.is(':visible')) {
              subMenu.slideUp();
              arrowIcon.removeClass('arrow-up');
            } else {
              $('.toggle-nav__lnb').slideUp();
              $('.fa-duotone').removeClass('arrow-up');
              subMenu.slideDown();
              arrowIcon.addClass('arrow-up');
            }
          }
        });
    } else {
      $('.toggle-nav__gnb--item').off('click');
      $('.toggle-nav__lnb').removeAttr('style');
      $('.fa-duotone').removeClass('arrow-up');
    }
  }

  // 초기 실행
  toggleLnbEvent();

  // 화면 크기 변경 감지하여 적용
  $(window).resize(toggleLnbEvent);

  // LNB 항목은 기본 동작 허용
  $('.toggle-nav__lnb--item a').click(function (event) {
    // 페이지 이동 동작 허용
  });
}

function footer() {
  const topBtn = document.querySelector('.quick_menu');

  // 스크롤 이벤트 감지
  window.addEventListener('scroll', function () {
    if (window.scrollY > 80) {
      topBtn.classList.add('show');
    } else {
      topBtn.classList.remove('show');
    }
  });

  // 클릭 시 스크롤 맨 위로
  topBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
